/* ZENOVIA – comportements (code original, sans dépendance) */
(() => {
  /* ---------- Format monétaire ---------- */
  const money = (cents) => {
    const fmt = window.zenMoneyFormat || '€{{amount_with_comma_separator}}';
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const grouped = i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, grouped)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, d === '00' ? grouped : `${grouped},${d}`)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, i)
      .replace(/\{\{\s*amount\s*\}\}/, d === '00' ? i : v);
  };
  window.zenMoney = money;

  /* ---------- Menu mobile ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-ref="menu-toggle"]');
    const close = e.target.closest('[data-ref="menu-close"]');
    const overlay = document.querySelector('[data-ref="mobile-menu-overlay"]');
    if (!overlay) return;
    if (toggle) {
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    } else if (close || (e.target === overlay && overlay.classList.contains('is-open'))) {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => (overlay.hidden = true), 300);
      document.querySelector('[data-ref="menu-toggle"]')?.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------- Icône panier : miroir desktop/mobile + ouverture du tiroir ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    const main = document.getElementById('cart-icon-bubble');
    const mirrors = document.querySelectorAll('[data-cart-icon-mirror]');
    if (main && mirrors.length) new MutationObserver(() => mirrors.forEach((m) => (m.innerHTML = main.innerHTML))).observe(main, { childList: true, subtree: true });
    mirrors.forEach((m) => m.addEventListener('click', (e) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      e.preventDefault();
      drawer.open(m);
    }));
  });

  /* ---------- Compteur du panier : toujours à jour ---------- */
  const syncCount = async () => {
    try {
      const r = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
      const c = await r.json();
      document.querySelectorAll('[data-ref="cart-count"]').forEach((el) => (el.textContent = c.item_count));
      document.querySelectorAll('.header__icon-count-bubble').forEach((el) => el.classList.toggle('is-empty', c.item_count === 0));
      syncGift(c);
    } catch (err) { /* hors ligne */ }
  };

  /* ---------- Cadeau automatique (gourde) : ajouté dès le palier, retiré en dessous ---------- */
  let giftBusy = false;
  const syncGift = async (c) => {
    if (giftBusy) return;
    /* Plus aucun produit payant : on retire tous les cadeaux (bundles, gourde) */
    const paid = c.items.filter((it) => it.final_line_price > 0 && !(it.properties && it.properties._zen_gift));
    if (c.items.length && !paid.length) {
      giftBusy = true;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart) { cart.classList.add('is-clearing'); const ci = cart.querySelector('cart-drawer-items'); if (ci) ci.classList.add('is-clearing'); await new Promise((ok) => setTimeout(ok, 320)); }
      const body = {};
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
      try {
        const r = await fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const res = await r.json();
        if (r.ok && cart && res.sections && cart.renderContents) cart.renderContents(res);
        if (r.ok && cart) { cart.classList.add('is-empty'); cart.classList.remove('is-clearing'); const inner = cart.querySelector('.drawer__inner'); if (inner) inner.classList.add('is-empty'); const items = cart.querySelector('cart-drawer-items'); if (items) items.classList.add('is-empty'); if (cart.close) setTimeout(() => cart.close(), 450); }
      } catch (err) { if (cart) cart.classList.remove('is-clearing'); }
      giftBusy = false;
      setTimeout(syncCount, 200);
      return;
    }
    const g = window.zenGift;
    if (!g || !g.variant) return;
    const line = c.items.find((it) => it.variant_id === g.variant);
    const total = c.items.reduce((sum, it) => (it.variant_id === g.variant ? sum : sum + it.final_line_price), 0);
    const want = c.item_count > 0 && total >= g.goal;
    if ((want && line && line.quantity === 1) || (!want && !line)) return;
    giftBusy = true;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = want ? { items: [{ id: g.variant, quantity: 1, properties: { _zen_gift: 'Offert' } }] } : { id: line.key, quantity: 0 };
    if (want && line) { body.items = []; body.id = line.key; body.quantity = 1; }
    const url = want && !line ? 'cart/add.js' : 'cart/change.js';
    if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
    try {
      const r = await fetch(window.Shopify.routes.root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const res = await r.json();
      if (r.ok && cart && res.sections && cart.renderContents) cart.renderContents({ ...res, id: line ? line.key : res.items?.[0]?.key ?? res.key });
      if (r.ok && cart) { const empty = (res.item_count ?? 1) === 0; cart.classList.toggle('is-empty', empty); const items = cart.querySelector('cart-drawer-items'); if (items) items.classList.toggle('is-empty', empty); }
    } catch (err) { /* ignore */ }
    giftBusy = false;
    setTimeout(syncCount, 200);
  };
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(syncCount, 150));
    const _fetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input && input.url;
      const p = _fetch.apply(this, arguments);
      if (url && /\/cart\/add/.test(url) && !(init && init.body && String(init.body).includes('_zen_gift'))) { try { window.dispatchEvent(new CustomEvent('zen:cart-add')); } catch (e) { /* noop */ } }
      if (url && /\/cart\/(add|change|update|clear)/.test(url)) p.then(() => setTimeout(syncCount, 200)).catch(() => {});
      return p;
    };
  });

  /* ---------- Réassurance du tiroir : un message à la fois ---------- */
  setInterval(() => {
    document.querySelectorAll('cart-drawer .zen-cart-trust').forEach((box) => {
      const items = [...box.children];
      if (items.length < 2) { items[0] && items[0].classList.add('is-active'); return; }
      const i = items.findIndex((x) => x.classList.contains('is-active'));
      items.forEach((x) => x.classList.remove('is-active'));
      items[(i + 1) % items.length].classList.add('is-active');
    });
  }, 3000);
  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('cart-drawer .zen-cart-trust > div:first-child').forEach((x) => x.classList.add('is-active')));

  /* ---------- Galerie produit ---------- */
  const initGallery = (root = document) => {
    root.querySelectorAll('[data-zen-gallery]:not([data-ready])').forEach((g) => {
      g.dataset.ready = '1';
      const list = g.querySelector('.product-media-gallery__list');
      const slides = [...list.children];
      const thumbs = [...g.querySelectorAll('.product-media-gallery__thumbnail')];
      const prev = g.querySelector('[data-prev]');
      const next = g.querySelector('[data-next]');
      const current = () => Math.round(list.scrollLeft / (list.clientWidth + 20));
      const go = (i) => {
        i = Math.max(0, Math.min(slides.length - 1, i));
        list.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      };
      const sync = () => {
        const c = current();
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === c));
        if (prev) prev.disabled = c === 0;
        if (next) next.disabled = c >= slides.length - 1;
        const active = thumbs[c];
        if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
      prev && prev.addEventListener('click', () => go(current() - 1));
      next && next.addEventListener('click', () => go(current() + 1));
      list.addEventListener('scroll', sync, { passive: true });
      g.addEventListener('zen:media', (e) => {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(e.detail));
        if (idx > -1) go(idx);
      });
      sync();
    });
  };

  /* ---------- Sliders génériques ---------- */
  const initSliders = (root = document) => {
    root.querySelectorAll('[data-zen-slider]:not([data-ready])').forEach((s) => {
      s.dataset.ready = '1';
      const track = s.querySelector('.zen-slider__track');
      const prev = s.querySelector('[data-prev]');
      const next = s.querySelector('[data-next]');
      if (!track) return;
      const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 16 : track.clientWidth);
      const update = () => {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  };

  /* ---------- Avant / après, onglets, popups ---------- */
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-zen-compare]')) e.target.closest('.zen-compare').style.setProperty('--pos', e.target.value + '%');
  });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.zen-tabs__btn');
    if (btn) {
      const tabs = btn.closest('[data-zen-tabs]');
      tabs.querySelectorAll('.zen-tabs__btn').forEach((b) => b.setAttribute('aria-selected', b === btn ? 'true' : 'false'));
      tabs.querySelectorAll('.zen-tabs__panel').forEach((p) => (p.hidden = p.id !== btn.getAttribute('aria-controls')));
    }
    const open = e.target.closest('[data-zen-open]');
    if (open) document.getElementById(open.dataset.zenOpen)?.showModal();
    const close = e.target.closest('[data-zen-close]');
    if (close) close.closest('dialog')?.close();
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('zen-dialog')) e.target.close();
  });

  /* ---------- Bloc achat : abonnement / offres / prix du bouton ---------- */
  const variantsOf = (box) => {
    try { return JSON.parse(box.closest('[data-zen-product]').querySelector('[data-zen-variants]').textContent); } catch (err) { return []; }
  };
  const selectedVariant = (box) => {
    const id = box.querySelector('input.product-variant-id')?.value;
    return variantsOf(box).find((v) => String(v.id) === String(id));
  };
  const refreshBreaks = (box, v) => {
    if (!v) return;
    box.querySelectorAll('[data-zen-break-item]').forEach((it) => {
      const q = +it.dataset.qty, pct = +it.dataset.pct || 0, amt = +it.dataset.amount || 0;
      const total = Math.max(0, Math.round((v.price * q * (100 - pct)) / 100) - amt);
      const base = v.compare_at_price > v.price ? v.compare_at_price : v.price;
      const compare = base * q;
      it.querySelector('[data-zen-break-price]').textContent = money(total);
      const cmp = it.querySelector('[data-zen-break-compare]');
      if (cmp) cmp.textContent = compare > total ? money(compare) : '';
      const sv = it.querySelector('[data-zen-break-saving]');
      if (sv) {
        const label = (sv.dataset.label ||= sv.textContent.replace(/\s[\d.,€\s%]+$/, '').trim() || 'Vous économisez');
        sv.textContent = compare > total ? `${label} ${pct > 0 && amt === 0 ? pct + ' %' : money(compare - total)}` : '';
      }
    });
  };
  const recompute = (box) => {
    const purchase = box.querySelector('input[name="zen-purchase"]:checked');
    const isSub = purchase && purchase.value === 'subscription';
    const planInput = box.querySelector('[data-zen-plan]');
    const planSel = box.querySelector('[data-zen-plan-select]');
    if (planInput) { planInput.value = isSub && planSel ? planSel.value : ''; planInput.disabled = !planInput.value; }
    box.querySelectorAll('[data-zen-sub-option]').forEach((o) => o.classList.toggle('subscription__option--selected', o.querySelector('input').checked));
    const breaks = box.querySelector('[data-zen-breaks]');
    const breaksHidden = !!(breaks && isSub && breaks.dataset.appliesTo === 'one_time');
    if (breaks) breaks.classList.toggle('quantity-breaks--hidden', breaksHidden);
    box.querySelectorAll('[data-zen-break-item]').forEach((it) => it.classList.toggle('quantity-break--selected', it.querySelector('input').checked));
    const br = box.querySelector('input[name="zen-break"]:checked');
    const qty = br && !breaksHidden ? +br.value : 1;
    const qtyInput = box.querySelector('[data-zen-qty]');
    if (qtyInput) qtyInput.value = qty;
    // Prix affiché dans le bouton (et la barre collante)
    let price = '', compare = '';
    if (isSub) {
      price = box.querySelector('[data-zen-sub-price]')?.textContent || '';
      compare = box.querySelector('[data-zen-sub-compare]')?.textContent || '';
    } else if (br && !breaksHidden) {
      const it = br.closest('[data-zen-break-item]');
      price = it.querySelector('[data-zen-break-price]')?.textContent || '';
      compare = it.querySelector('[data-zen-break-compare]')?.textContent || '';
    } else {
      const v = selectedVariant(box);
      if (v) { price = money(v.price); compare = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
    }
    const section = box.closest('[data-zen-product]') || document;
    section.querySelectorAll('[data-zen-atc-price]').forEach((el) => { if (price) el.textContent = price; });
    section.querySelectorAll('[data-zen-atc-compare]').forEach((el) => (el.textContent = compare));
  };
  const initBuy = (root = document) => {
    root.querySelectorAll('[data-zen-buy]:not([data-ready])').forEach((box) => {
      box.dataset.ready = '1';
      box.addEventListener('change', () => recompute(box));
      recompute(box);
    });
  };

  /* Changement de variante (événement Dawn) */
  const onVariant = (section, variantId) => {
    const box = section && section.querySelector('[data-zen-buy]');
    if (!box || !variantId) return;
    const v = variantsOf(box).find((x) => String(x.id) === String(variantId));
    if (!v) return;
    refreshBreaks(box, v);
    const one = box.querySelector('[data-zen-one-time-price]');
    if (one) one.textContent = money(v.price);
    recompute(box);
    if (v.featured_media_id) section.querySelector('[data-zen-gallery]')?.dispatchEvent(new CustomEvent('zen:media', { detail: v.featured_media_id }));
  };
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const section = document.querySelector(`[data-zen-product][data-section="${ev.data.sectionId}"]`);
        onVariant(section, ev.data.variant && ev.data.variant.id);
      });
    }
  });

  /* ---------- Barre d'achat collante ---------- */
  const initSticky = (root = document) => {
    root.querySelectorAll('[data-zen-sticky]:not([data-ready])').forEach((bar) => {
      bar.dataset.ready = '1';
      const form = document.getElementById(bar.dataset.formId);
      const main = form && form.querySelector('.product-form__submit');
      if (!main) return;
      new IntersectionObserver(([en]) => {
        bar.dataset.active = !en.isIntersecting && en.boundingClientRect.top < 0 ? 'true' : 'false';
      }).observe(main);
      bar.querySelector('[data-zen-sticky-btn]').addEventListener('click', () => main.click());
    });
  };

  /* ---------- Produits offerts : ajoutés juste après l'ajout principal ---------- */
  const addGifts = async (box) => {
    const br = box.querySelector('input[name="zen-break"]:checked');
    const breaks = box.querySelector('[data-zen-breaks]');
    if (!br || (breaks && breaks.classList.contains('quantity-breaks--hidden'))) return;
    const ids = (br.closest('[data-zen-break-item]').dataset.gifts || '').split(',').filter(Boolean);
    if (!ids.length) return;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items: ids.map((id) => ({ id: +id, quantity: 1, properties: { _zen_gift: 'Offert' } })) };
    if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
    try {
      const r = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const res = await r.json();
      if (r.ok && cart && res.sections && cart.renderContents) cart.renderContents({ ...res, id: res.items?.[0]?.key ?? res.key });
    } catch (err) { /* le produit principal est déjà dans le panier */ }
  };
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
        if (!ev || ev.source !== 'product-form') return;
        const box = document.querySelector('[data-zen-buy]');
        if (box) setTimeout(() => addGifts(box), 50);
      });
    }
  });

  /* ---------- Estimation de livraison ---------- */
  const initDelivery = (root = document) => {
    root.querySelectorAll('[data-zen-delivery]:not([data-ready])').forEach((el) => {
      el.dataset.ready = '1';
      const o = el.dataset;
      const skipSat = o.noSat === 'true', skipSun = o.noSun === 'true';
      const addDays = (n) => {
        const d = new Date();
        if (d.getHours() >= +o.cutoff) n += 1;
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          const w = d.getDay();
          if ((w === 6 && skipSat) || (w === 0 && skipSun)) continue;
          n--;
        }
        return d;
      };
      const opts = o.format === 'numbers' ? { day: '2-digit', month: '2-digit' } : { day: 'numeric', month: 'long' };
      if (o.weekday === 'true') opts.weekday = 'long';
      const fmt = (d) => d.toLocaleDateString('fr-FR', opts);
      el.querySelector('[data-min]').textContent = fmt(addDays(+o.min));
      el.querySelector('[data-max]').textContent = fmt(addDays(+o.max));
    });
  };

  /* ---------- Cross-sell : ajout au panier ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-zen-xsell-add]');
    if (!btn) return;
    e.preventDefault();
    const row = btn.closest('.cross-sell__item');
    const id = row.querySelector('select')?.value || btn.dataset.variantId;
    btn.disabled = true;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items: [{ id: +id, quantity: 1 }] };
    if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
    try {
      const r = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const res = await r.json();
      if (cart && res.sections) { cart.classList.remove('is-empty'); cart.renderContents({ ...res, id: res.items?.[0]?.key ?? res.key }); }
      else window.location.href = window.Shopify.routes.root + 'cart';
    } finally { btn.disabled = false; }
  });

  /* ---------- Code promo dans le tiroir ---------- */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-zen-discount]');
    if (!f) return;
    e.preventDefault();
    const code = f.querySelector('input').value.trim();
    if (code) window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.location.pathname + '?zen_cart=1')}`;
  });
  if (new URLSearchParams(location.search).get('zen_cart') === '1') {
    window.addEventListener('load', () => setTimeout(() => document.querySelector('cart-drawer')?.open?.(), 300));
  }

  /* ---------- Stories ---------- */
  let storyTimer;
  const modal = () => {
    let m = document.getElementById('ZenStoryModal');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'ZenStoryModal'; m.className = 'zen-story-modal';
    m.innerHTML = '<div class="zen-story-modal__inner"><div class="zen-story-modal__bars"></div><button class="zen-story-modal__close" aria-label="Fermer">×</button><button class="zen-story-modal__nav zen-story-modal__nav--prev" aria-label="Précédent"></button><button class="zen-story-modal__nav zen-story-modal__nav--next" aria-label="Suivant"></button><div class="zen-story-modal__media"></div></div>';
    document.body.appendChild(m);
    return m;
  };
  const playStory = (items, i = 0) => {
    const m = modal(); clearTimeout(storyTimer);
    if (i < 0) i = 0;
    if (i >= items.length) { m.classList.remove('is-open'); return; }
    m.classList.add('is-open');
    const bars = m.querySelector('.zen-story-modal__bars');
    bars.innerHTML = items.map((_, k) => `<i><b style="width:${k < i ? 100 : 0}%"></b></i>`).join('');
    const it = items[i]; const holder = m.querySelector('.zen-story-modal__media');
    holder.innerHTML = it.type === 'video' ? `<video src="${it.src}" autoplay playsinline muted></video>` : `<img src="${it.src}" alt="">`;
    const bar = bars.children[i].firstChild; const next = () => playStory(items, i + 1);
    if (it.type !== 'video') {
      const dur = (it.duration || 5) * 1000;
      bar.style.transition = `width ${dur}ms linear`;
      requestAnimationFrame(() => requestAnimationFrame(() => (bar.style.width = '100%')));
      storyTimer = setTimeout(next, dur);
    } else {
      const v = holder.querySelector('video');
      v.addEventListener('timeupdate', () => (bar.style.width = (v.currentTime / v.duration) * 100 + '%'));
      v.addEventListener('ended', next);
    }
    m.querySelector('.zen-story-modal__nav--next').onclick = next;
    m.querySelector('.zen-story-modal__nav--prev').onclick = () => playStory(items, i - 1);
    m.querySelector('.zen-story-modal__close').onclick = () => { clearTimeout(storyTimer); m.classList.remove('is-open'); holder.innerHTML = ''; };
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-zen-story]');
    if (t) { try { playStory(JSON.parse(t.dataset.zenStory)); } catch (err) { /* noop */ } }
  });

  /* ---------- Compte à rebours des offres (boucle, ancré sur l'heure) ---------- */
  const pad = (n) => (n < 10 ? '0' : '') + n;
  setInterval(() => {
    document.querySelectorAll('[data-zen-timer]').forEach((t) => {
      const cycle = (+t.dataset.cycle || 3) * 3600;
      const left = cycle - (Math.floor(Date.now() / 1000) % cycle);
      const v = t.querySelector('[data-zen-timer-value]');
      if (v) v.textContent = `${pad(Math.floor(left / 3600))}:${pad(Math.floor((left % 3600) / 60))}:${pad(left % 60)}`;
    });
  }, 1000);

  /* ---------- Menu mobile : le compte à rebours ne dépasse pas la carte ---------- */
  const fitDrawerTimer = () => {
    document.querySelectorAll('.header__mobile-menu .zen-cd').forEach((cd) => {
      const nav = cd.closest('.header__mobile-menu-nav');
      const card = nav && nav.querySelector('.header-drawer-menu-under-menu');
      const ref = card || nav;
      if (!ref) return;
      const w = Math.round(ref.getBoundingClientRect().width);
      if (!w) return;
      const cur = Math.round(cd.getBoundingClientRect().width);
      const ml = parseFloat(cd.style.marginLeft || '0');
      if (cur === w && !ml) return;
      cd.style.setProperty('width', w + 'px', 'important');
      cd.style.setProperty('max-width', w + 'px', 'important');
      cd.style.setProperty('margin-left', '0', 'important');
      cd.style.setProperty('margin-right', '0', 'important');
    });
  };
  new MutationObserver(fitDrawerTimer).observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'hidden'], subtree: true });
  window.addEventListener('resize', fitDrawerTimer);
  setInterval(fitDrawerTimer, 600);

  /* ---------- Footer mobile : deux colonnes indépendantes (pas de trou) ---------- */
  const footerCols = () => {
    document.querySelectorAll('.footer .footer__content').forEach((fc) => {
      const mobile = window.innerWidth < 750;
      const wrapped = fc.dataset.zenCols === '1';
      if (mobile && !wrapped) {
        const kids = Array.from(fc.children);
        if (kids.length < 3) return;
        const left = document.createElement('div'); left.className = 'footer__col';
        const right = document.createElement('div'); right.className = 'footer__col';
        kids.forEach((k, i) => (i % 2 === 0 ? left : right).appendChild(k));
        fc.append(left, right); fc.dataset.zenCols = '1';
      } else if (!mobile && wrapped) {
        const cols = Array.from(fc.querySelectorAll(':scope > .footer__col'));
        const l = Array.from(cols[0].children), r = Array.from(cols[1].children);
        const out = []; for (let i = 0; i < Math.max(l.length, r.length); i++) { if (l[i]) out.push(l[i]); if (r[i]) out.push(r[i]); }
        cols.forEach((c) => c.remove()); out.forEach((k) => fc.appendChild(k)); delete fc.dataset.zenCols;
      }
    });
  };
  footerCols();
  window.addEventListener('resize', footerCols);
  document.addEventListener('shopify:section:load', footerCols);

  /* ---------- Effet récompense quand un palier de la jauge est atteint ---------- */
  const confetti = (host) => {
    const colors = ['#fa7315', '#201f1f', '#ffd166', '#06d6a0', '#ef476f', '#118ab2'];
    for (let i = 0; i < 26; i++) {
      const d = document.createElement('span');
      d.className = 'zen-confetti';
      d.style.background = colors[i % colors.length];
      d.style.setProperty('--dx', `${(Math.random() - .5) * 320}px`);
      d.style.setProperty('--dy', `${-40 - Math.random() * 160}px`);
      d.style.animationDelay = `${Math.random() * .15}s`;
      host.appendChild(d);
      setTimeout(() => d.remove(), 1400);
    }
  };
  const watchTier = () => {
    const el = document.querySelector('cart-drawer .zen-cart-progress[data-zen-tier]');
    if (!el) return;
    const tier = +el.dataset.zenTier;
    let prev = 0; try { prev = +(sessionStorage.getItem('zenTier') || 0); } catch (e) { /* noop */ }
    if (tier > prev) { confetti(el); el.classList.add('zen-just-unlocked'); setTimeout(() => el.classList.remove('zen-just-unlocked'), 1200); }
    try { sessionStorage.setItem('zenTier', String(tier)); } catch (e) { /* noop */ }
  };
  new MutationObserver(watchTier).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Carte volante : l'image du produit décolle, trace un arc et atterrit dans le panier ---------- */
  const flyToCart = () => {
    const img = document.querySelector('.product-media-gallery .is-active img, .product-media-gallery img, .product-section img');
    let target = Array.from(document.querySelectorAll('#cart-icon-bubble, [data-cart-icon-mirror]')).find((t) => t.offsetParent !== null);
    if (!img || !img.animate) return;
    if (!target) { target = document.querySelector('#cart-icon-bubble') || document.body; }
    if (flyToCart._t && Date.now() - flyToCart._t < 1200) return; flyToCart._t = Date.now();
    const a = img.getBoundingClientRect(); let b = target.getBoundingClientRect();
    if (b.bottom < 0 || b.top > window.innerHeight || b.width === 0) b = { left: window.innerWidth - 44, top: 16, width: 28, height: 28 };
    const size = Math.min(160, Math.max(110, a.width * .55));
    const fly = document.createElement('div');
    fly.className = 'zen-fly';
    const pic = img.cloneNode(true); pic.removeAttribute('srcset'); pic.removeAttribute('sizes'); pic.className = ''; pic.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
    fly.appendChild(pic);
    const x0 = a.left + a.width / 2 - size / 2, y0 = a.top + a.height / 2 - size / 2;
    const x1 = b.left + b.width / 2 - 14, y1 = b.top + b.height / 2 - 14;
    fly.style.cssText = `left:${x0}px;top:${y0}px;width:${size}px;height:${size}px;`;
    document.body.appendChild(fly);
    const dx = x1 - x0, dy = y1 - y0, scaleEnd = 28 / size, lift = Math.max(90, Math.abs(dy) * .35);
    fly.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
      { transform: `translate(${dx * .18}px, ${-lift}px) scale(1.12) rotate(-4deg)`, opacity: 1, offset: .28 },
      { transform: `translate(${dx * .62}px, ${dy * .45 - lift * .5}px) scale(.6) rotate(6deg)`, opacity: .95, offset: .66 },
      { transform: `translate(${dx}px, ${dy}px) scale(${scaleEnd}) rotate(14deg)`, opacity: .15, offset: 1 },
    ], { duration: 950, easing: 'cubic-bezier(.22,.8,.25,1)', fill: 'forwards' });
    setTimeout(() => {
      fly.remove();
      target.classList.remove('zen-bump'); void target.offsetWidth; target.classList.add('zen-bump');
      setTimeout(() => target.classList.remove('zen-bump'), 650);
    }, 930);
  };
  document.addEventListener('submit', (e) => { if (e.target.matches('form[action*="/cart/add"]')) flyToCart(); }, true);
  window.addEventListener('zen:cart-add', flyToCart);

  const init = (root) => { initGallery(root); initSliders(root); initBuy(root); initSticky(root); initDelivery(root); };
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  new MutationObserver(() => init(document)).observe(document.documentElement, { childList: true, subtree: true });
})();
